import React from "react";
import PropTypes from "prop-types";
import styles from './Chart.less';
import { scaleTime } from "d3-scale";
import { format } from "d3-format";
import { utcDay } from "d3-time";
import { timeFormat } from "d3-time-format";
import { ChartCanvas, Chart } from "react-stockcharts";
import { CandlestickSeries, LineSeries } from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last, timeIntervalBarWidth } from "react-stockcharts/lib/utils";
import CustomOHLCTooltip from './CustomOHLCTooltip';
import { HoverTooltip } from "react-stockcharts/lib/tooltip";
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
import {
EdgeIndicator
} from "react-stockcharts/lib/coordinates";
import i18next from 'i18next';
import config from './../../config';
let myFlag = 0;
let dynamicTime = true;
import $ from 'jquery';

@connect(
  state => ({
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  language:state.dashboardRoot.commonReducer.language
}),
{ ...commonActions})
class CandleStickChart extends React.Component {
  componentDidMount() {
    this.node.subscribe("zoomlistner", { listener: this.handleEvents })
  }

  componentWillUnmount() {
    // this.node.unsubscribe("zoomlistner")
  }
  handleEvents = (type, moreProps, state) => {
    try{
      if (type === "zoom" || type === "panend") {
        if (this.props.onZoomEvent) {
          this.props.onZoomEvent(moreProps.xScale.domain());
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvents', component:"CandleStickChart"});
    }
  }
  render() {
    const { width, data, ratio, durationType, liveCategory, decimals,nextData } = this.props;
    $(document).ready(function(){
      $("rect").hover(function(){
        dynamicTime = false;
      },
      function(){
        dynamicTime = true;
      });
    });
    let myData = data;
    let testmsg = "Candle Stick";
    let lastpointtime = [];
    var dataLength = 0;
    if (this.props.nextData.length !== 0) {
      dataLength = Number(this.props.nextData[this.props.nextData.length-1].open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}).length;
      lastpointtime = this.props.nextData[this.props.nextData.length-1].date;
    }
    else if (this.props.data.length !== 0) {
      dataLength = Number(this.props.data[this.props.data.length-1].open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}).length;
    }
    let h = new Date(lastpointtime).getHours();
    let m = new Date(lastpointtime).getMinutes();
    let s = new Date(lastpointtime).getSeconds();
    /*passing last data of nextData time to ohlc comp and comparing with onhover data time so that if hovering on
    live plot of candle the header time also updates else static */

    let time = h+':'+m+':'+s;
    myData = myData.concat(this.props.nextData);
    let livePlotData = this.props.nextData[this.props.nextData.length-1];
    //const xAccessor = d => d && d.date ? new Date(newDate21) : '';
    const xAccessor = d => d && d.date ? d.date : '';
    // const xExtents = [
    //   xAccessor(last(data)),
    //   xAccessor(data.length > 300 ? data[Math.round(data.length/1.1)] : data[0])
    // ];
    // const xExtents = [
    //   new Date(xAccessor(data[0]) - 1000*60*60*24*4),
    //   new Date(xAccessor(data[data.length - 1]) + 1000*60*60*24*4)
    // ];
    //const xExtents = [ new Date(data[0].ts-86400000), new Date(data[data.length - 1].ts+86400000) ];
    const start = data.length > 20 ? xAccessor(myData[myData.length - 21]) : xAccessor(myData[0]) ;
    const end = xAccessor(myData[myData.length - 1]);
    //const xExtents = [start, end];
    let margin = {
        top: 20,
        right: 5,
        bottom: 20,
        left: 70
    };
    let height = (this.props.height > 400 ? this.props.height : 400 ) - margin.top - margin.bottom;
    var gridHeight = height - margin.top - margin.bottom;
    var color='#000';
    var axisColor='#000';
    let ohlcTooltipOrigin = [
        this.props.width< 500 ?  -40 : (this.props.language != 'AR' ? 0 : 500),
        -36
      ];
    var yGrid =  {
        innerTickSize: -1 * (width - 75),
        tickStrokeDasharray: 'Dot',
        tickStrokeOpacity: 0.2,
        tickStrokeWidth: 1,
        stroke: axisColor,
        tickStroke:color
    };
    var yGridDark =  {
        innerTickSize: -1 * (width - 75),
        tickStrokeDasharray: 'Dot',
        tickStrokeOpacity: 0.4,
        tickStrokeWidth: 2,
        stroke: "#b2b1ae",
        tickStroke: "#b2b1ae"
    };
    var xGridDark = {
      innerTickSize: -1 * gridHeight,
      tickStrokeDasharray: 'Solid',
      tickStrokeOpacity: 0.3,
      tickStrokeWidth: 1,
      tickStroke:"#b2b1ae",
      stroke: "#b2b1ae"
  } ;
    var xGrid =  {
        stroke: axisColor,
        tickStroke:color
    };
    const displayTextsZoom = {
      d: "T",
      o: "O",
      h: "H",
      l: "L",
      c: "C",
      v: "V",
      na: "n/a"
    };
    const defTickTimeFormat = timeFormat("%H:%M:%S");
    let liveTime = new Date();
    let now = defTickTimeFormat(liveTime);
    let tickTimeFormat = d3.time.format.multi([
      [":%Ss", function(d) { return d.getSeconds(); }],
      ["%H:%M", function(d) { return d.getHours() || d.getMinutes(); }],
      //["%H:%M", function(d) { return d.getMinutes(); }],
      ["%H:%M", function() { return true }]
    ]);

    var tickFormatFn = function(d) {
        return tickTimeFormat(d);
    };
    var numberFormat = function(d) {
      return d.toLocaleString(navigator.language,{ minimumFractionDigits:decimals,maximumFractionDigits:decimals});
    }
    let tooltipContent = ({ currentItem }) => {
      if (this.props.language !== 'AR') {
        if ((defTickTimeFormat(lastpointtime) === defTickTimeFormat(currentItem.date))) {
          myFlag = 0;
          return {
            x: (i18next.t('open')) + ': '+Number(livePlotData.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
            y: [{label: i18next.t("high"), value: ' '+Number(livePlotData.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("low"), value: '  '+Number(livePlotData.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label:i18next.t("close"), value: Number(livePlotData.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t('time'), value: now}]
            .filter(line => line.value)
          };
        }
        else {
          myFlag = 1;
          return {
            x: (i18next.t('open')) + ': '+Number(currentItem.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
            y: [{label: i18next.t("high"), value: ' '+Number(currentItem.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("low"), value: '  '+Number(currentItem.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("close"), value: Number(currentItem.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label:this.props.displayTexts ? i18next.t(this.props.displayTexts.d).split(':')[0] : i18next.t('time'), value: ' '+ defTickTimeFormat(currentItem.date)}]
            .filter(line => line.value)
          };
        }
      }
      else {
        if ((defTickTimeFormat(lastpointtime) === defTickTimeFormat(currentItem.date))) {
          myFlag = 0;
          return {
            x: (Number(livePlotData.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})) + ':  '+i18next.t('O'),
            y: [{label: Number(livePlotData.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: ' '+i18next.t("H")}, {label: Number(livePlotData.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: ' '+i18next.t("L")}, {label:Number(livePlotData.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: ' '+i18next.t("C")}, {label: now, value: i18next.t('time')}]
            .filter(line => line.value)
          };
        }
        else {
          myFlag = 1;
          return {
            x: (Number(currentItem.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})) + ':  '+i18next.t('O'),
            y: [{label: Number(currentItem.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: ' '+i18next.t("H")}, {label: Number(currentItem.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: ' '+i18next.t("L")}, {label: Number(currentItem.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: ' '+i18next.t("C")}, {label: defTickTimeFormat(currentItem.date), value: i18next.t('time')}]
            .filter(line => line.value)
          };
        }
      }
    }
    //---to re-render chart zoom-level
    const zoomLevel = this.props.zoomLevel ? this.props.zoomLevel.map((item) => new Date(item)) : undefined;
    const xExtents = zoomLevel !== undefined ? [zoomLevel[0]  ,end] : [start, end];
    return (
      <ChartCanvas
          height={gridHeight}
          padding={{ left: 0, right: 30 }}
          ratio={ratio}
          width={width}
          margin={margin}
          type="svg"
          seriesName="CandleStick"
          //clamp={'both'}
          pointsPerPxThreshold={4}
          data={myData}
          xAccessor={xAccessor}
          displayXAccessor={xAccessor}
          xScale={scaleTime()}
          ref={node => { this.node = node; } }
          xExtents = {xExtents}>

        <Chart id={1} yExtents={d => [d.high + Math.pow(10, -1 * (decimals-1)), d.low - Math.pow(10, -1 * (decimals-1))]}>
        { this.props.selectedCssColor === "DR" ?
          <XAxis
              axisAt="bottom"
              orient="bottom"
              ticks={6}
              tickFormat={tickFormatFn}
              {...xGridDark}
          />
          :
          <XAxis
              axisAt="bottom"
              orient="bottom"
              ticks={6}
              tickFormat={tickFormatFn}
              {...xGrid}
          />
        }
        { this.props.selectedCssColor === "DR" ?
          <YAxis axisAt="left" orient="left" tickFormat={numberFormat} zoomEnabled={false} {...yGridDark}  />
          :<YAxis axisAt="left" orient="left" tickFormat={numberFormat} zoomEnabled={false} {...yGrid}  />
        }
        <CandlestickSeries width={timeIntervalBarWidth(this.props.timeInterval)}  stroke={d => (d.open < d.close) ? config.increaseRateColor: config.decreaseRateColor} fill={ d => (d.open < d.close) ? config.increaseRateColor: config.decreaseRateColor} widthRatio={0.3} opacity={0.8} wickStroke={ d => (d.open < d.close) ? config.increaseRateColor: config.decreaseRateColor}/>
          <CustomOHLCTooltip
            candleHeader={testmsg}
            livePlotData={livePlotData}
            myFlag={myFlag}
            time={time}
            dynamicTime={dynamicTime}
            forChart={1}
            className={this.props.language != 'AR' ? `${styles.historicalToopTip}` : `${styles.historicalToopTip} chartTimeHead`}
            fontSize={13}
            origin={ohlcTooltipOrigin}
            ohlcFormat={decimals}
            lastPointFromGraph={myData[myData.length-1]}
            displayTexts={this.props.displayTexts}
            zoomWidth={this.props.width}
            styleObj = {this.props.styleObj}
          />
          <HoverTooltip
            tooltipContent={tooltipContent}
            fontSize={13}
            bgfill={this.props.selectedThemes.tooltipHoverBg}
            fill={this.props.selectedThemes.tooltipHoverBg}
            fontFill={this.props.selectedThemes.tooltipHoverClr}
            stroke={this.props.selectedThemes.tooltipHoverClr}
          />
        </Chart>
      </ChartCanvas>
    );
  }
}

CandleStickChart.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  onZoomEvent: PropTypes.func,
  type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
  durationType: PropTypes.oneOf(['Minute', 'Hour']).isRequired,
  liveCategory: PropTypes.oneOf(['Bid', 'Ask']).isRequired,
  zoomLevel: PropTypes.array
};

CandleStickChart = fitWidth(CandleStickChart);

export default CandleStickChart;
